const listColumn = {
  TICKER: 'ticker',
  RTD11: 'fundamental.rtd11', // Market cap
  ISA3: 'fundamental.isa3', // Rev TTM
  ISA20: 'fundamental.isa20', // Net profit TTM
  FRYQ30: 'fundamental.fryq30', // net Profit Forecast
  RTD21: 'fundamental.rtd21', // P/E
  RTD54: 'fundamental.rtd54', // Forward P/E
  RTD14: 'fundamental.rtd14', // EPS TTM
  RTD53: 'fundamental.rtd53', // EPS Forward
  RTD7: 'fundamental.rtd7', // Book Value Per share
};

export default {
  listColumn,

  ORGAN_CODE: 'organCode',
};
